import React from 'react'
import { Field } from 'redux-form'
import { Row, Container } from 'react-bootstrap'
import { renderTextField } from '../../../Forms/fieldRenderers'

function CamposPesado0 (props) {
  const { label, validate, disabled, onBlurInput = null } = props

  const handleOnBlur = (e, input) => {
    if (onBlurInput) {
      onBlurInput()
    }
  }

  return (
    <div style={{ width: '100%' }} >
      <Container>
        <Row style={{ justifyContent: 'center' }} >
          <Field
            className='cpa-grande'
            name='numero'
            type='text'
            label={label}
            maxLength={11}
            component={renderTextField}
            autoFocus
            onBlur={handleOnBlur}
            disabled={disabled}
            validate={validate}
            placeholder='10200000000'
          />
        </Row>
      </Container>
    </div>
  )
}

export default CamposPesado0
